import { render, staticRenderFns } from "./about-introduction.vue?vue&type=template&id=061bb917&scoped=true&"
import script from "./about-introduction.vue?vue&type=script&lang=js&"
export * from "./about-introduction.vue?vue&type=script&lang=js&"
import style0 from "./about-introduction.vue?vue&type=style&index=0&id=061bb917&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061bb917",
  null
  
)

export default component.exports